// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__27Hdlm7IDnE_906sTLq4Uf"};